import React, { useEffect, useState } from "react";
import "./NotFound.css";
import { Link } from "react-router-dom";

export default function NotFound(props) {
  const [show404, setShow404] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    // Matrix digital rain effect
    const canvas = document.getElementById("matrix-canvas");
    const ctx = canvas.getContext("2d");

    // Set canvas to full screen
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Characters for the matrix rain
    const matrixChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789$+-*/=%\"'#&_(),.;:?!\\|{}<>[]^~";

    // Font size
    const fontSize = 16;
    const columns = canvas.width / fontSize;

    // Array of drops - one per column
    const drops = [];

    // Initialize all drops to start at random position outside screen
    for (let i = 0; i < columns; i++) {
      drops[i] = Math.floor((Math.random() * -canvas.height) / fontSize);
    }

    // Drawing the characters
    function draw() {
      // Black BG with opacity for the trail effect
      ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#0F0"; // Green text
      ctx.font = fontSize + "px monospace";

      // For each column/drop
      for (let i = 0; i < drops.length; i++) {
        // Pick a random character
        const text =
          matrixChars[Math.floor(Math.random() * matrixChars.length)];

        // Draw the character
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        // Reset drop to top if it's at the bottom
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }

        // Move drop down
        drops[i]++;
      }
    }

    // Animation loop
    const matrixInterval = setInterval(draw, 50);

    // Show elements with staggered timing - increasing the delay between components
    const timer1 = setTimeout(() => setShow404(true), 3000);
    const timer2 = setTimeout(() => setShowMessage(true), 4500); // Increased from 3500 to 4500
    const timer3 = setTimeout(() => setShowButtons(true), 6000); // Increased from 4000 to 6000

    // Clean up on unmount
    return () => {
      clearInterval(matrixInterval);
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const canvas = document.getElementById("matrix-canvas");
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="matrix-container">
      <canvas id="matrix-canvas" className="matrix-canvas"></canvas>

      <div className="matrix-content">
        <div
          className="animated-404"
          style={{ opacity: show404 ? 1 : 0, transition: "opacity 0.5s ease" }}
        >
          <span className="digit digit-4">4</span>
          <span className="digit digit-0">0</span>
          <span className="digit digit-4-2">4</span>
          <div className="glitch-effect"></div>
        </div>

        <p
          className="matrix-message"
          style={{
            opacity: showMessage ? 1 : 0,
            transition: "opacity 0.5s ease",
          }}
        >
          The system has been compromised. Reality as you know it has collapsed.
        </p>

        <div
          className="matrix-buttons"
          style={{
            opacity: showButtons ? 1 : 0,
            transition: "opacity 0.5s ease",
          }}
        >
          <Link to="/" className="pill-link">
            <button className="red-pill">
              <span className="pill-text">Red Pill: Return to Reality</span>
              <span className="pill-glow"></span>
            </button>
          </Link>
          <a
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            target="_blank"
            rel="noopener noreferrer"
            className="pill-link"
          >
            <button className="blue-pill">
              <span className="pill-text">Blue Pill: Go on an Adventure</span>
              <span className="pill-glow"></span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
